import { CardInfoText, CardSectionTitle, GappedCardContainer } from "../styles";
import { DoctorBaseAttributes, Gender } from "../../../interfaces";
import { Link, styled } from "@mui/material";
import { DocumentProps } from "../../../interfaces";

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: "none",
  cursor: "pointer",
  fontWeight: "500",
}));

export const SignatureCard: React.FC<{
  doctorData: Pick<DoctorBaseAttributes, "name" | "lastName" | "gender">;
  treatmentPDF: DocumentProps;
  signatureType: "FES" | "FEA";
}> = ({ doctorData, treatmentPDF, signatureType }) => {
  const genderString = doctorData.gender === Gender.MALE ? "Dr. " : "Dra. ";
  const signatureText =
    signatureType === "FES"
      ? "Firma electrónica simple"
      : "Firma Electrónica Avanzada";

  return (
    <GappedCardContainer gap={"8px"}>
      <CardInfoText justifyContent={"center"}>
        Documento emitido por MekiDoc con {signatureText}
        {treatmentPDF.documentUrl && (
          <>
            {" - "}
            <StyledLink
              color="primary"
              target="_blank"
              onClick={() => {
                window.open(treatmentPDF.documentUrl, "_blank");
              }}
            >
              Ver Documento Firmado
            </StyledLink>
          </>
        )}
      </CardInfoText>

      <div>
        <CardSectionTitle>Firmante</CardSectionTitle>
        <CardInfoText>{`${genderString} ${doctorData.name} ${doctorData.lastName}`}</CardInfoText>
      </div>
    </GappedCardContainer>
  );
};
